import { Typography, Grid2, Box } from "@mui/material";
import pic from "../../../../ui-utils/latestPics/EquityBenefits.svg"
import Styles from "./Web.module.css"
import { AnimationOnScroll } from "react-animation-on-scroll";
import { useLanguage } from "../../../../Context/LangContext";
import en from "../../../../i18n/English/Trade Invest/benefit.json";
import hi from "../../../../i18n/Hindi/Trade Invest/benefit.json";
import kn from "../../../../i18n/Kannada/Trade Invest/benefit.json";
import gu from "../../../../i18n/Gujarati/Trade Invest/benefit.json";
import ma from "../../../../i18n/Marathi/Trade Invest/benefit.json";

export default function BenefitsWeb() {
    const { language } = useLanguage();
    const translations = { en, hi, kn,ma,gu };
    const t = translations[language];
    return (
        <>
            <Box className={Styles.outerBox}>
                <AnimationOnScroll animateIn="animate__fadeInDown"
                    animateOnce={true}
                    className={Styles.customFadeInLeft}>
                    <div className={Styles.headingContainer}>
                        <div className={Styles.gradientBackground}></div>
                        <Typography className={Styles.heading} style={{ fontWeight: 600 }}>
                            {t.heading}
                        </Typography>
                    </div>
                <Typography className={Styles.subtxt}>
                    {/* Buying or selling shares used to mean calling your broker or mailing a letter. Shares were physical, clearing was slow, and risks like fraud were common. This all changed with the introduction of online trading in India. Here are more benefits: */}
                    {t.subtxt}
                </Typography>
                </AnimationOnScroll>

                <Grid2 className={Styles.innerCard}>
                    <AnimationOnScroll animateIn="animate__fadeInLeft"
                        animateOnce={true}
                        className={Styles.customFadeInLeft}>
                    </AnimationOnScroll>
                    <img src={pic} alt="equity" className={Styles.pic} />
                    <AnimationOnScroll animateIn="animate__fadeInRight"
                        animateOnce={true}
                        className={Styles.customFadeInLeft}>
                    <Grid2 className={Styles.txtCard}>
                        <Typography className={Styles.innertxt1}>
                                <span className={Styles.innertxtspan} style={{ fontWeight: 600 }}>
                                {/* No Paperwork: */}
                                {t.benefits[0].title}{" "}
                            </span>
                            {/* Demat accounts eliminate the need for extensive paperwork and physical shareholding. */}
                                {t.benefits[0].desc}
                        </Typography>

                        <Typography className={Styles.innertxt1} sx={{paddingTop:"30px"}}>
                                <span className={Styles.innertxtspan} style={{ fontWeight: 600 }}>
                                {/* Invest in Your Favoured Instruments: */}
                                    {t.benefits[1].title}{" "}
                            </span>
                            {/* You can subscribe to IPOs, mutual funds, or invest in public companies that interest you, whether short-term or long-term. */}
                                {t.benefits[1].desc}
                        </Typography>

                        <Typography className={Styles.innertxt1} sx={{ paddingTop: "30px" }}>
                                <span className={Styles.innertxtspan} style={{ fontWeight: 600 }}>
                                {/* Faster & Diversified Trading: */}
                                    {t.benefits[2].title}{" "}
                            </span>
                            {/* Buy or sell shares instantly across segments with quick settlements and multi-leg trading strategies. */}
                                {t.benefits[2].desc}
                        </Typography>

                        <Typography className={Styles.innertxt1} sx={{ paddingTop: "30px" }}>
                                <span className={Styles.innertxtspan} style={{ fontWeight: 600 }}>
                                {/* Protects Your Holdings: */}
                                    {t.benefits[3].title}{" "}
                            </span>
                            {/* Your assets are in dematerialized form, safeguarding them from loss, theft, or damage. */}
                                {t.benefits[3].desc}
                        </Typography>

                        <Typography className={Styles.innertxt1} sx={{ paddingTop: "30px" }}>
                                <span className={Styles.innertxtspan} style={{ fontWeight: 600 }}>
                                {/* Multiple Instruments in One Account: */}
                                    {t.benefits[4].title}{" "}
                            </span>
                            {/* Trade stocks, commodities, F&O, ELSS, currencies, and more through your online demat account. */}
                                {t.benefits[4].desc}
                        </Typography>



                    </Grid2>
                 </AnimationOnScroll>


                </Grid2>
            </Box>
        </>
    )
}